/* ATTCU — interaction engine. No frameworks; WAAPI + IO + rAF, hand-set. */
(() => {
  'use strict';
  const doc = document;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- registration-mark cursor ---------- */
  if (fine && !reduced) {
    const cur = doc.querySelector('.cursor');
    if (cur) {
      let x = -100, y = -100, cx = -100, cy = -100, on = false;
      addEventListener('pointermove', (e) => {
        x = e.clientX; y = e.clientY;
        if (!on) { on = true; cur.classList.add('is-on'); cx = x; cy = y; }
      }, { passive: true });
      addEventListener('pointerdown', (e) => {
        const g = cur.cloneNode(true);
        g.className = 'cursor-ghost';
        g.style.left = e.clientX + 'px'; g.style.top = e.clientY + 'px';
        doc.body.appendChild(g);
        setTimeout(() => g.remove(), 520);
      });
      doc.addEventListener('mouseleave', () => { on = false; cur.classList.remove('is-on'); });
      const live = (t) => t.closest('a, button, input, [data-live]');
      addEventListener('pointerover', (e) => cur.classList.toggle('is-live', !!live(e.target)), { passive: true });
      (function tick() {
        cx += (x - cx) * 0.22; cy += (y - cy) * 0.22;
        cur.style.transform = `translate(${cx}px, ${cy}px)` +
          (cur.classList.contains('is-live') ? ' scale(1.6) rotate(45deg)' : '');
        requestAnimationFrame(tick);
      })();
      cur.style.transition = 'color .18s, opacity .3s';
    }
  }

  /* ---------- header ---------- */
  const hdr = doc.querySelector('.hdr');
  if (hdr) {
    let last = scrollY;
    addEventListener('scroll', () => {
      const yNow = scrollY;
      hdr.classList.toggle('is-inked', yNow > 40);
      if (Math.abs(yNow - last) > 8) {
        hdr.classList.toggle('is-hidden', yNow > last && yNow > 320);
        last = yNow;
      }
    }, { passive: true });
  }

  /* ---------- reveals ---------- */
  const revealables = doc.querySelectorAll('[data-reveal]');
  if (revealables.length) {
    const io = new IntersectionObserver((entries) => {
      for (const en of entries) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealables.forEach((el, i) => {
      if (!el.style.getPropertyValue('--reveal-delay')) {
        el.style.setProperty('--reveal-delay', ((i % 4) * 0.08) + 's');
      }
      io.observe(el);
    });
  }

  /* ---------- every impression differs: per-load drift ---------- */
  if (!reduced) {
    const r = (a, b) => (a + Math.random() * (b - a)).toFixed(3);
    doc.querySelectorAll('.stamp').forEach((el) => {
      el.style.setProperty('--mis-fx', r(0.02, 0.07) + 'em');
      el.style.setProperty('--mis-fy', r(0.015, 0.055) + 'em');
      el.style.setProperty('--mis-kx', r(-0.065, -0.02) + 'em');
      el.style.setProperty('--mis-ky', r(-0.05, -0.012) + 'em');
    });
    doc.querySelectorAll('.plate-frame').forEach((el) => {
      el.style.setProperty('--lean', r(-0.7, 0.7) + 'deg');
    });
  }
  try {
    const el = doc.querySelector('[data-impression]');
    if (el) {
      const n = (parseInt(localStorage.getItem('attcu-impression') || '0', 10) + 1);
      localStorage.setItem('attcu-impression', String(n));
      el.textContent = ' \u00b7 THIS IS IMPRESSION \u2116' + String(n).padStart(3, '0');
    }
  } catch (e) { /* private mode */ }

  /* ---------- hero stamp-in ---------- */
  const hero = doc.querySelector('.hero');
  if (hero) requestAnimationFrame(() => hero.classList.add('is-stamping'));

  /* ---------- thesis marquee (scroll-velocity linked) ---------- */
  const track = doc.querySelector('.marquee');
  if (track && !reduced) {
    const chunk = track.firstElementChild;
    if (chunk) {
      while (track.scrollWidth < innerWidth * 2.2) track.appendChild(chunk.cloneNode(true));
      let off = 0, vel = 0, lastY = scrollY;
      addEventListener('scroll', () => {
        vel += Math.min(Math.abs(scrollY - lastY), 60) * 0.06;
        lastY = scrollY;
      }, { passive: true });
      const w = () => chunk.getBoundingClientRect().width;
      (function run() {
        off -= 1.15 + vel; vel *= 0.92;
        const cw = w();
        if (cw && -off >= cw) off += cw;
        track.style.transform = `translate3d(${off}px,0,0)`;
        requestAnimationFrame(run);
      })();
    }
  }

  /* ---------- plate tilt ---------- */
  if (fine && !reduced) {
    doc.querySelectorAll('.plate').forEach((plate) => {
      const frame = plate.querySelector('.plate-frame');
      if (!frame) return;
      plate.addEventListener('pointermove', (e) => {
        const r = frame.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5;
        const py = (e.clientY - r.top) / r.height - 0.5;
        frame.style.setProperty('--tilt-x', (py * -5).toFixed(2) + 'deg');
        frame.style.setProperty('--tilt-y', (px * 6).toFixed(2) + 'deg');
      });
      plate.addEventListener('pointerleave', () => {
        frame.style.setProperty('--tilt-x', '0deg');
        frame.style.setProperty('--tilt-y', '0deg');
      });
    });
  }

  /* ---------- mobile prism: plates light as they centre in view ---------- */
  if (matchMedia('(hover: none)').matches && !reduced) {
    const litIO = new IntersectionObserver((ens) => {
      ens.forEach((en) => en.target.classList.toggle('is-lit',
        en.isIntersecting && en.intersectionRatio >= 0.55));
    }, { threshold: [0, 0.55, 1] });
    doc.querySelectorAll('.plate').forEach((pl) => litIO.observe(pl));
  }

  /* ---------- the medium's tell: rare glitch ticks ---------- */
  if (!reduced) {
    const plates = [...doc.querySelectorAll('.plate')];
    if (plates.length) {
      (function tell() {
        setTimeout(() => {
          const p = plates[Math.floor(Math.random() * plates.length)];
          p.classList.add('is-glitching');
          setTimeout(() => p.classList.remove('is-glitching'), 200);
          tell();
        }, 5000 + Math.random() * 9000);
      })();
    }
  }

  /* ---------- ink progress bar (articles) ---------- */
  const inkbar = doc.querySelector('.inkbar i');
  if (inkbar) {
    const update = () => {
      const h = doc.documentElement;
      const p = h.scrollTop / (h.scrollHeight - h.clientHeight || 1);
      inkbar.style.width = (p * 100).toFixed(2) + '%';
    };
    addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- print-index hover peek ---------- */
  const peek = doc.querySelector('.pindex-peek');
  if (peek && fine) {
    const img = peek.querySelector('img');
    let raf = null;
    doc.querySelectorAll('.pindex-row[data-image]').forEach((row) => {
      row.addEventListener('pointerenter', () => {
        const src = row.getAttribute('data-image');
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
        peek.classList.add('is-on');
      });
      row.addEventListener('pointerleave', () => peek.classList.remove('is-on'));
    });
    addEventListener('pointermove', (e) => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        peek.style.left = Math.min(e.clientX + 28, innerWidth - peek.offsetWidth - 20) + 'px';
        peek.style.top = Math.min(e.clientY - peek.offsetHeight / 2, innerHeight - peek.offsetHeight - 20) + 'px';
        raf = null;
      });
    }, { passive: true });
  }

  /* ---------- plates slider ---------- */
  doc.querySelectorAll('[data-slider]').forEach((slider) => {
    const track = slider.querySelector('.slider-track');
    const slides = [...slider.querySelectorAll('.slide')];
    const count = slider.querySelector('[data-slide-count]');
    if (!track || slides.length < 2) return;
    let idx = 0, timer = null, inView = false, busy = null;
    const go = (i) => {
      idx = (i + slides.length) % slides.length;
      if (busy) clearTimeout(busy);
      busy = setTimeout(() => { busy = null; }, 950);
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    };
    const sync = () => {
      let best = 0, bd = Infinity;
      slides.forEach((sl, i) => {
        const d = Math.abs(sl.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < bd) { bd = d; best = i; }
      });
      idx = best;
      if (count) count.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
    };
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    slider.querySelector('[data-slide-prev]')?.addEventListener('click', () => { stop(); go(idx - 1); });
    slider.querySelector('[data-slide-next]')?.addEventListener('click', () => { stop(); go(idx + 1); });
    const start = () => { if (!timer && !reduced) timer = setInterval(() => { if (inView && !busy && !doc.hidden) go(idx + 1); }, 4600); };
    const stop = () => { clearInterval(timer); timer = null; setTimeout(start, 9000); };
    if (matchMedia('(hover: hover)').matches) {
      slider.addEventListener('pointerenter', () => { clearInterval(timer); timer = null; });
      slider.addEventListener('pointerleave', start);
    }
    track.addEventListener('pointerdown', () => { clearInterval(timer); timer = null; setTimeout(start, 9000); }, { passive: true });
    new IntersectionObserver((en) => {
      const was = inView;
      inView = en[0].isIntersecting;
      if (inView && !was) { clearInterval(timer); timer = null; start(); }
    }, { threshold: 0.3 }).observe(slider);
    sync(); start();
  });

  /* ---------- in-view video playback ---------- */
  doc.querySelectorAll('video[data-io-play]').forEach((v) => {
    new IntersectionObserver((en) => {
      if (en[0].isIntersecting) { v.play().catch(() => {}); }
      else { v.pause(); }
    }, { threshold: 0.25 }).observe(v);
  });

  /* ---------- loop figure draws itself ---------- */
  const fig = doc.querySelector('.loop-fig');
  if (fig) {
    fig.querySelectorAll('.draw').forEach((p) => {
      try { p.style.setProperty('--len', Math.ceil(p.getTotalLength())); } catch (e) { /* non-path */ }
    });
    new IntersectionObserver((en, o) => {
      if (en[0].isIntersecting) { fig.classList.add('is-in'); o.disconnect(); }
    }, { threshold: 0.35 }).observe(fig);
  }
})();
